import Core from '@/core/module';
import _ from 'lodash';

export default class Offerte extends Core {
    init() {
        this.addEventListeners();
    }

    addEventListeners() {
        this.$el.on('change', '[name="quantity"]', (e) => {
            e.preventDefault();

            const $el = $(e.currentTarget);
            const $form = $el.closest('form');
            const product_id = $form.data('product-id');
            const $quantity = $form.find('[name="quantity"]');
            const variationProperties = $form.find('[data-product_variations]').data('product_variations');
            let hasErrors = false;

            const selectedVariationProperties = {};

            _.each($form.find('select[name^="attribute_"]'), (select) => {
                const $el = $(select);

                selectedVariationProperties[$el.attr('name')] = $el.val();
            });

            const founded = _.filter(variationProperties, (item, key) => {
                let success = true;

                _.each(item.attributes, (attribute, attributeKey) => {
                    if(selectedVariationProperties[attributeKey] !== attribute) {
                        success = false;
                    }
                });

                return success;
                // console.log('aa: ', _.difference(item.attributes, selectedVariationProperties));

            });

            const fieldParameters = {
                min: getNumber($quantity.attr('min'), 0),
                max: getNumber($quantity.attr('max'), 0),
                step: getNumber($quantity.attr('step'), 0),
                quantity: getNumber($quantity.val(), 0)
            };

            const $errorUl = this.$el.find(`[data-errorgroup~="quantity"]`).hide();
            $errorUl.find('[data-inputname="quantity"]').remove();

            if(!founded[0] && _.size(selectedVariationProperties) > 0) {
                $errorUl.append(`<li data-inputname="quantity">Deze combinatie is niet mogelijk</li>`);
                hasErrors = true;
            }
            else if(fieldParameters.quantity < fieldParameters.min) {
                $errorUl.append(`<li data-inputname="quantity">De minimale order hoeveelheid is ${fieldParameters.min} stuks<br /><a href="#" class="inline-link" round-that><span>aantal verhogen</span> <i class="icon-arrow-right"></i></a></li>`);
                hasErrors = true;
            }

            else if(fieldParameters.quantity > fieldParameters.max && fieldParameters.max != 0 && fieldParameters.max > fieldParameters.min) {
                $errorUl.append(`<li data-inputname="quantity">De maximale order hoeveelheid is ${fieldParameters.max} stuks</li>`);
                hasErrors = true;
            }

            else if(fieldParameters.quantity / fieldParameters.step != Math.round(fieldParameters.quantity / fieldParameters.step)) {
                $errorUl.append(`<li data-inputname="quantity">Dit product wordt alleen geleverd per ${fieldParameters.step} stuks <br /><a href="#" class="inline-link" round-that><span>afronden naar boven</span> <i class="icon-arrow-right"></i></a></li>`);
                hasErrors = true;
            }

            if(hasErrors) {
                $errorUl.show();
                return;
            }
        });

        this.$el.find('[name="quantity"]').trigger('change');
    }
}

function getNumber(number, defaultNumber) {
    return isNaN(parseInt(number, 10)) ? defaultNumber : parseInt(number, 10);
}